import {
    READ_PINNED_FROM_FORAGE,
    RESET_PINNED,
    ADD_PINNED,
    REMOVE_PINNED,
    TOGGLE_PINNED,
} from './constants'
import { USERS_LOGIN_USER, USERS_FORGET_USERS, USERS_LOGOUT_USER } from '../constants'
import { add, remove, toggle } from '../helpers'

// Initial state for users in the store
const initialState = {}
// const initialState  = {
//     tq: ['testuser_1'],
//     sisi: [],
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Read the users pinned state from forage
        case READ_PINNED_FROM_FORAGE:
            return action.payload

        // Reset the pinned state to empty
        case RESET_PINNED:
        case USERS_FORGET_USERS:
            return {}

        case USERS_LOGIN_USER: {
            const { serverId, user: { userId, pinned } } = action.payload
            if (!pinned) return state
            return add(state, serverId, userId)
        }

        // Add userId to list of pinned users
        case ADD_PINNED: {
            const { serverId, userId } = action.payload
            return add(state, serverId, userId)
        }

        // Remove userId from list of pinned users (if included)
        case USERS_LOGOUT_USER:
        case REMOVE_PINNED: {
            const { serverId, userId } = action.payload
            return remove(state, serverId, userId)
        }

        // Toggle whether the given user is remembered or not (if found)
        case TOGGLE_PINNED: {
            const { serverId, userId } = action.payload
            return toggle(state, serverId, userId)
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/pinned/reducer.js